module.exports = __webpack_public_path__ + "static/media/info11_Militante_representante.904af5c8.png";